.countdown {
  text-align: center;
  margin: 0 auto;
  max-width: 700px;

  .countdown__value {
    margin-bottom: 0.25rem;
  }

  .countdown__title {
    margin-bottom: 0;
    color: var(--color-text-alternate);
  }

  &__ended-text {
    display: none;

    &.live-edit-mode {
      display: block;
      margin: 75px auto 15px;
    }
  }
}

.section--custom {
  .countdown {
    .countdown__title {
      color: inherit;
      opacity: 0.6;
    }
  }
}

#end-date-message-container.hidden {
  display: none !important;
}
